<template>
  <div>
    <van-tabbar v-if="type==='bigTab'&& tabbarList">
      <van-tabbar-item class="nav-block" v-for="(item, index) in tabbarList" :key="index"
                       :url="item.link">
        <template #icon>
          <img class="nav-img" :src="item.icon" alt="">
        </template>
        {{item.title}}
      </van-tabbar-item>
    </van-tabbar>
    <van-tabbar v-model="active" v-if="type==='footTab'&& tabbarList">
      <van-tabbar-item v-for="(item, index) in tabbarList" :key="index"
                       :url="item.link">
        <template #icon="props">
          <img class="nav-img" :src="props.active ? tabbarList[active].icon_acitve:item.icon" alt="">
        </template>
        {{item.title}}
      </van-tabbar-item>
    </van-tabbar>
  </div>

</template>

<script>
  import Vue from 'vue';
  import {Tabbar, TabbarItem} from 'vant';

  Vue.use(Tabbar);
  Vue.use(TabbarItem);

  export default {
    name: "tabbarComponent",
    data() {
      return {
        active: 3,
      };
    },
    props: [
      'type',
      'tabbarList'
    ],
    methods: {}
  }
</script>

<style>
  .bigTab .van-tabbar--fixed {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
    position: static;
    height: auto;
  }

  .bigTab .nav-block .van-tabbar-item__text {
    font-size: .75rem;
    color: #333333;
  }

  .bigTab .van-tabbar-item--active {
    color: #333333;
  }

</style>
